import React from 'react';

import { IIconProps, TIconType } from '../interface';

const Refresh: TIconType = (props?: IIconProps) => {
	return (
		<svg
			fill='none'
			height='40'
			viewBox='0 0 40 40'
			width='40'
			{...props?.innerSvgProps}
		>
			<path
				d='M14.7313 17.3467H10.9813V13.5967'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
			<path
				d='M14.1688 25.8313C15.3223 26.9857 16.7923 27.7721 18.3928 28.091C19.9933 28.4099 21.6525 28.2469 23.1604 27.6227C24.6682 26.9984 25.9571 25.941 26.8639 24.5842C27.7707 23.2273 28.2548 21.632 28.2548 20C28.2548 18.368 27.7707 16.7727 26.8639 15.4158C25.9571 14.059 24.6682 13.0016 23.1604 12.3774C21.6525 11.7531 19.9933 11.5901 18.3928 11.909C16.7923 12.2279 15.3223 13.0143 14.1688 14.1688L10.9813 17.3469'
				stroke='#2E2E6B'
				strokeLinecap='round'
				strokeLinejoin='round'
			/>
		</svg>
	);
};

export default Refresh;
